/* Presentation adapter: the HTML structure is owned by Liquid. */
(() => {
  function render(container, notices) {
    const template = container.querySelector('template[data-campaign-notice-template]');
    const content = container.querySelector('[data-campaign-notice-content]');
    if (!template || !content) return;
    const fragments = notices.map(notice => {
      const fragment = template.content.cloneNode(true);
      fragment.querySelectorAll('[data-campaign-field]').forEach(element => {
        const value = notice[element.dataset.campaignField];
        element.textContent = typeof value === 'string' ? value : '';
        element.hidden = !element.textContent;
      });
      return fragment;
    });
    content.replaceChildren(...fragments);
    container.hidden = fragments.length === 0;
  }
  window.MhlCampaignNotice = Object.freeze({ render });
})();
